import { render, staticRenderFns } from "./WarningLinkModal.vue?vue&type=template&id=b78976b6"
import script from "./WarningLinkModal.vue?vue&type=script&lang=js"
export * from "./WarningLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports